// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconGifPath = 'M3 17v-5.83c.39.142.705.358 1.067.63.713.535 1.601 1.2 3.268 1.2 1.667 0 2.554-.665 3.267-1.2.62-.464 1.067-.8 2.067-.8 1 0 1.447.336 2.065.8.554.416 1.218.906 2.266 1.105V17H3ZM13 3v4h4v3.83c-.389-.142-.703-.358-1.064-.63-.713-.535-1.6-1.2-3.267-1.2-1.667 0-2.554.665-3.267 1.2-.62.464-1.067.8-2.067.8-1.001 0-1.448-.336-2.068-.8C4.713 9.784 4.049 9.294 3 9.095V3h10Zm3.949 2H15V3.051c.979.199 1.75.97 1.949 1.949ZM14.5 1H1v18h18V5.5C19 3.019 16.981 1 14.5 1Z';
var IconGif = baseIcon('IconGif', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconGifPath
});
export default IconGif;
//# sourceMappingURL=index.js.map